import React, { useState } from "react";
import "./InterviewsPage.css";
const InterviewsPage = () => {
  const [activeTab, setActiveTab] = useState("upcoming");
  const [showModals, setShowModals] = useState({
  sched: false,
  feedback: false,
  resched: false,
  cancel: false,
});
  const [ratings, setRatings] = useState({ r1: 0, r2: 0, r3: 0, r4: 0 });
  /* ========================= MODAL FUNCTIONS ========================= */ 
  const openModal =
    (modal) => {
      setShowModals((prev) => ({ ...prev, [modal]: true }));
    };
  const closeModal = (modal) => {
    setShowModals((prev) => ({ ...prev, [modal]: false }));
  };
  const closeAllModals = () => {
    setShowModals({
      sched: false,
      feedback: false,
      resched: false,
      cancel: false,
    });
  };
  /* ========================= TOAST ========================= */ 
  const toast =
    (msg, type = "success") => {
      const t = document.createElement("div");
      t.className = `og-toast ${type === "warn" ? "og-toast-warn" : type === "error" ? "og-toast-error" : "og-toast-success"}`;
      const icon =
        type === "warn"
          ? "fa-triangle-exclamation"
          : type === "error"
            ? "fa-times-circle"
            : "fa-check-circle";
      t.innerHTML = ` <i class="fa-solid ${icon}"></i> <span>${msg}</span> `;
      document.body.appendChild(t);
      setTimeout(() => {
        t.classList.add("og-toast-hide");
        setTimeout(() => {
          t.remove();
        }, 300);
      }, 2800);
    };
  /* ========================= RATING ========================= */ 
  const setRating =
    (id, value) => {
      setRatings((prev) => ({ ...prev, [id]: value }));
    };
  /* ========================= TAB ========================= */ const changeTab =
    (tab) => {
      setActiveTab(tab);
    };
  /* ========================= PROFILE ========================= */ const openCandidateProfile =
    () => {
      window.location.href = "recruitment-candidate-profile.html";
    };
  return (
    <>
      
      {/* ===================================================== TOPBAR ===================================================== */}
      <div className="topbar">
        
        <i className="fa-solid fa-calendar-check topbar-calendar-icon"></i>
        <div className="breadcrumb topbar-breadcrumb">
          
          <a href="#">Recruitment</a>
          <i className="fa-solid fa-chevron-right topbar-chevron"></i>
          <strong className="topbar-current"> Interviews </strong>
        </div>
        <div className="top-right">
          
          <div className="top-user">
            
            <div className="top-avatar">AM</div>
            <div>
              
              <div className="top-user-name"> Arun Mishra </div>
              <div className="top-user-role"> HR Admin </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================================================== MAIN CONTAINER ===================================================== */}
      <div className="container-fluid position-relation">
                <div className="interviews-page-header Page-head">
          <div className='leftside-head'>
            <h2 className="interviews-page-title ">
              <i className="fa-solid fa-calendar-check interviews-page-title-icon"></i> Interviews
            </h2>
            <div className="breadcrumb"> All scheduled interview rounds across all jobs </div>
          </div>
          <button className="btn btn-primary" onClick={()=> openModal("sched")} > <i className="fa-solid fa-calendar-plus"></i> Schedule Interview </button>
        </div>
        <div className="page-hd">
          
          {/* ================= STATS ================= */}
          <div className="stat-strip interviews-bx">
            
            <div className="stat-card c-today">
              
              <div className="stat-lbl">Today</div>
              <div className="stat-val stat-val-primary">3</div>
              <div className="stat-sub"> Scheduled today </div>
            </div>
            <div className="stat-card c-week">
              
              <div className="stat-lbl">This Week</div>
              <div className="stat-val stat-val-blue">11</div>
              <div className="stat-sub"> Jun 23 – Jun 27 </div>
            </div>
            <div className="stat-card c-pending">
              
              <div className="stat-lbl"> Feedback Pending </div>
              <div className="stat-val stat-val-amber"> 4 </div>
              <div className="stat-sub"> Awaiting panel input </div>
            </div>
            <div className="stat-card c-done">
              
              <div className="stat-lbl">Completed</div>
              <div className="stat-val stat-val-green"> 18 </div>
              <div className="stat-sub"> This month </div>
            </div>
          </div>
          {/* ================= FILTER ================= */}
          <div className="filter-bar">
            
            <div className="filter-row">
              
              <div className="interview-filter-search">
                
                <i className="fa-solid fa-magnifying-glass interview-filter-search-icon"></i>
                <input
                  className="interview-filter-input"
                  placeholder="Search candidate, job, panel member…"
                />
              </div>
              <select className="og-select interview-filter-select">
                
                <option>All Status</option> <option>Pending</option>
                <option>Cleared</option> <option>Not Cleared</option>
                <option>Cancelled</option>
              </select>
              <select className="og-select interview-filter-select">
                
                <option>All Jobs</option>
                <option> JOB-2026-001 — Sr Frontend Dev </option>
                <option> JOB-2026-002 — Product Manager </option>
                <option> JOB-2026-004 — Data Analyst </option>
              </select>
              <select className="og-select interview-filter-select">
                
                <option>All Panelists</option> <option>Priya Sharma</option>
                <option>Arun Mishra</option> <option>Rahul Dev</option>
                <option>Neha Gupta</option>
              </select>
              <input
                type="date"
                className="interview-filter-date"
                title="Filter by date"
              />
            </div>
          </div>
        </div>
        {/* ===================================================== TABS ===================================================== */}
        <div className="tab-bar">
          
          <button
            className={`tab-btn ${activeTab === "upcoming" ? "active" : ""}`}
            onClick={() => changeTab("upcoming")}
          >
            
            <i className="fa-solid fa-calendar-days"></i> Upcoming
            <span className="tab-count">8</span>
          </button>
          <button
            className={`tab-btn ${activeTab === "today" ? "active" : ""}`}
            onClick={() => changeTab("today")}
          >
            
            <i className="fa-solid fa-circle-dot tab-today-icon"></i> Today
            <span className="tab-count">3</span>
          </button>
          <button
            className={`tab-btn ${activeTab === "pending-fb" ? "active" : ""}`}
            onClick={() => changeTab("pending-fb")}
          >
            
            <i className="fa-solid fa-star-half-stroke"></i> Feedback Pending
            <span className="tab-count">4</span>
          </button>
          <button
            className={`tab-btn ${activeTab === "past" ? "active" : ""}`}
            onClick={() => changeTab("past")}
          >
            
            <i className="fa-solid fa-clock-rotate-left"></i> Past
            <span className="tab-count">18</span>
          </button>
        </div>
        {/* ===================================================== UPCOMING TAB ===================================================== */}
        {activeTab === "upcoming" && (
          <div id="tab-upcoming">
            
            <div className="section-header"> This Week </div>
            {/* Rahul Kumar */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">26</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe interview-stripe-amber"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand interview-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Rahul Kumar
                </div>
                <div className="ir-round">
                  
                  Round 2 — HR Interview ·
                  <span className="interview-job-code">
                    
                    JOB-2026-001
                  </span>
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 11:00 AM – 12:00
                    PM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-video"></i> Google Meet
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-hourglass-half"></i> 60 min
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av panel-avatar-priya" title="Priya Sharma">
                  
                  PS
                </div>
              </div>
              <span className="ir-status s-pending"> Pending </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> Feedback
                </button>
                <button
                  className="btn-ghost btn-xs"
                  onClick={() => openModal("resched")}
                  title="Reschedule"
                >
                  
                  <i className="fa-solid fa-calendar-pen"></i>
                </button>
                <button
                  className="btn-ghost btn-xs interview-cancel-btn"
                  onClick={() => openModal("cancel")}
                  title="Cancel"
                >
                  
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
            {/* Meera Joshi */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">27</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe interview-stripe-blue"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand interview-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Meera Joshi
                </div>
                <div className="ir-round">
                  
                  Round 1 — Technical Screening ·
                  <span className="interview-job-code">
                    
                    JOB-2026-002
                  </span>
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 2:00 PM – 3:00
                    PM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-video"></i> Zoom
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-hourglass-half"></i> 60 min
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av panel-avatar-neha" title="Neha Gupta">
                  
                  NG
                </div>
                <div className="pan-av panel-avatar-rahul" title="Rahul Dev">
                  
                  RD
                </div>
              </div>
              <span className="ir-status s-pending"> Pending </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> Feedback
                </button>
                <button
                  className="btn-ghost btn-xs"
                  onClick={() => openModal("resched")}
                  title="Reschedule"
                >
                  
                  <i className="fa-solid fa-calendar-pen"></i>
                </button>
                <button
                  className="btn-ghost btn-xs interview-cancel-btn"
                  onClick={() => openModal("cancel")}
                  title="Cancel"
                >
                  
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
            <div className="section-header next-week-header"> Next Week </div>
            {/* Siddharth Rao */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">30</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe interview-stripe-purple"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand interview-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Siddharth Rao
                </div>
                <div className="ir-round">
                  
                  Round 1 — Technical + System Design ·
                  <span className="interview-job-code">
                    
                    JOB-2026-005
                  </span>
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 10:00 AM – 11:30
                    AM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-building"></i> In-person
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-hourglass-half"></i> 90 min
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av panel-avatar-priya" title="Priya Sharma">
                  
                  PS
                </div>
                <div className="pan-av panel-avatar-arun" title="Arun Mishra">
                  
                  AM
                </div>
              </div>
              <span className="ir-status s-pending"> Pending </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> Feedback
                </button>
                <button
                  className="btn-ghost btn-xs"
                  onClick={() => openModal("resched")}
                  title="Reschedule"
                >
                  
                  <i className="fa-solid fa-calendar-pen"></i>
                </button>
                <button
                  className="btn-ghost btn-xs interview-cancel-btn"
                  onClick={() => openModal("cancel")}
                  title="Cancel"
                >
                  
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {/* ===================================================== TODAY TAB ===================================================== */}
        {activeTab === "today" && (
          <div id="tab-today">
            
            <div className="today-badge">
              
              <i className="fa-solid fa-circle-dot"></i> Today — June 26,
              2026
            </div>
            {/* Rahul */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">26</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe today-stripe-primary"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand today-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Rahul Kumar
                </div>
                <div className="ir-round">
                  
                  Round 2 — HR Interview · JOB-2026-001
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 11:00 AM – 12:00
                    PM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-video"></i> Google Meet
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av today-panel-priya" title="Priya Sharma">
                  
                  PS
                </div>
              </div>
              <span className="ir-status s-pending"> Pending </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-primary btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> Submit Feedback
                </button>
                <button
                  className="btn-ghost btn-xs"
                  onClick={() => openModal("resched")}
                  title="Reschedule"
                >
                  
                  <i className="fa-solid fa-calendar-pen"></i>
                </button>
              </div>
            </div>
            {/* Amit */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">26</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe today-stripe-blue"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand today-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Amit Kumar
                </div>
                <div className="ir-round">
                  
                  Round 1 — Technical · JOB-2026-001
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 2:00 PM – 3:00
                    PM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-video"></i> Zoom
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av today-panel-rahul" title="Rahul Dev">
                  
                  RD
                </div>
                <div className="pan-av today-panel-neha" title="Neha Gupta">
                  
                  NG
                </div>
              </div>
              <span className="ir-status s-pending"> Pending </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-primary btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> Submit Feedback
                </button>
                <button
                  className="btn-ghost btn-xs"
                  onClick={() => openModal("resched")}
                  title="Reschedule"
                >
                  
                  <i className="fa-solid fa-calendar-pen"></i>
                </button>
              </div>
            </div>
            {/* Priya Singh */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">26</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe today-stripe-green"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand today-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Priya Singh
                </div>
                <div className="ir-round">
                  
                  Round 3 — Director Round · JOB-2026-001
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 4:00 PM – 5:00
                    PM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-building"></i> In-person
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av today-panel-arun" title="Arun Mishra">
                  
                  AM
                </div>
              </div>
              <span className="ir-status s-cleared"> Cleared </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> View Feedback
                </button>
              </div>
            </div>
          </div>
        )}
        {/* ===================================================== FEEDBACK PENDING TAB ===================================================== */}
        {activeTab === "pending-fb" && (
          <div id="tab-pending-fb">
            
            <div className="pending-feedback-alert">
              
              <i className="fa-solid fa-triangle-exclamation"></i> 4 interviews
              are awaiting feedback from panel members. Feedback is important
              for pipeline decisions.
            </div>
            {/* Neha */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">24</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe pending-feedback-stripe"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand pending-feedback-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Neha Kapoor
                </div>
                <div className="ir-round">
                  
                  Round 2 — HR · JOB-2026-001 ·
                  <span className="pending-feedback-overdue-amber">
                    
                    2 days overdue
                  </span>
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-solid fa-user"></i> Panel: Priya
                    Sharma
                  </span>
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 10:00 AM – 11:00
                    AM
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av pending-panel-priya"> PS </div>
              </div>
              <span className="ir-status s-pending"> Feedback Pending </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-warn btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> Add Feedback
                </button>
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => toast("Reminder sent to Priya Sharma")}
                >
                  
                  <i className="fa-solid fa-bell"></i> Remind
                </button>
              </div>
            </div>
            {/* Meera */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">22</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe pending-feedback-stripe-red"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand pending-feedback-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Meera Joshi
                </div>
                <div className="ir-round">
                  
                  Round 1 — Technical · JOB-2026-004 ·
                  <span className="pending-feedback-overdue-red">
                    
                    4 days overdue
                  </span>
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-solid fa-user"></i> Panel: Rahul Dev, Neha
                    Gupta
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av pending-panel-rahul"> RD </div>
                <div className="pan-av pending-panel-neha"> NG </div>
              </div>
              <span className="ir-status s-pending"> Feedback Pending </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-warn btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> Add Feedback
                </button>
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => toast("Reminder sent to panel members")}
                >
                  
                  <i className="fa-solid fa-bell"></i> Remind All
                </button>
              </div>
            </div>
          </div>
        )}
        {/* ===================================================== PAST TAB ===================================================== */}
        {activeTab === "past" && (
          <div id="tab-past">
            
            {/* Priya Singh */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">20</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe past-stripe-green"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand past-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Priya Singh
                </div>
                <div className="ir-round">
                  
                  Round 2 — System Design · JOB-2026-001
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 11:00 AM – 12:30
                    PM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-video"></i> Google Meet
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-user"></i> Rahul Dev, Priya
                    Sharma
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av past-panel-rahul"> RD </div>
                <div className="pan-av past-panel-priya"> PS </div>
              </div>
              <span className="ir-status s-cleared"> Cleared </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> View Feedback
                </button>
              </div>
            </div>
            {/* Vikash */}
            <div className="ir">
              
              <div className="ir-date">
                
                <div className="ir-day">18</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe past-stripe-red"></div>
              <div className="ir-info">
                
                <div
                  className="ir-cand past-candidate"
                  onClick={openCandidateProfile}
                >
                  
                  Vikash Roy
                </div>
                <div className="ir-round">
                  
                  Round 1 — Technical Screening · JOB-2026-001
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 10:00 AM – 11:00
                    AM
                  </span>
                  <span>
                    
                    <i className="fa-solid fa-video"></i> Zoom
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av past-panel-rahul"> RD </div>
              </div>
              <span className="ir-status s-failed"> Not Cleared </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() => openModal("feedback")}
                >
                  
                  <i className="fa-solid fa-star"></i> View Feedback
                </button>
              </div>
            </div>
            {/* Neeraj */}
            <div className="ir past-ir-cancelled">
              
              <div className="ir-date">
                
                <div className="ir-day">15</div>
                <div className="ir-month">Jun</div>
              </div>
              <div className="ir-stripe past-stripe-gray"></div>
              <div className="ir-info">
                
                <div className="ir-cand"> Neeraj Sharma </div>
                <div className="ir-round">
                  
                  Round 1 — Technical · JOB-2026-004
                </div>
                <div className="ir-meta">
                  
                  <span>
                    
                    <i className="fa-regular fa-clock"></i> 3:00 PM – 4:00
                    PM
                  </span>
                </div>
              </div>
              <div className="ir-panel">
                
                <div className="pan-av past-panel-cancelled"> RD </div>
              </div>
              <span className="ir-status s-cancelled"> Cancelled </span>
              <div className="ir-actions">
                
                <button
                  className="btn btn-outline btn-xs"
                  onClick={() =>
                    toast("No feedback — interview was cancelled", "warn")
                  }
                >
                  
                  Details
                </button>
              </div>
            </div>
          </div>
        )}
        {/* ===================================================== SCHEDULE INTERVIEW MODAL ===================================================== */}
        {showModals.sched && (
          <div
            className="modal-overlay open"
            id="schedModal"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closeModal("sched");
              }
            }}
          >
            
            <div className="modal-box wide">
              
              <div className="modal-head">
                
                <div className="modal-icon sched-modal-icon">
                  
                  <i className="fa-solid fa-calendar-plus"></i>
                </div>
                <div className="sched-modal-title-wrap">
                  
                  <div className="modal-title"> Schedule Interview </div>
                </div>
                <button
                  className="modal-close-btn"
                  onClick={() => closeModal("sched")}
                >
                  
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                
                <div className="fg">
                  
                  <label>
                    
                    Candidate <span className="sched-required">*</span>
                  </label>
                  <select className="og-select" defaultValue="">
                    
                    <option value=""> Select candidate… </option>
                    <option>Rahul Kumar</option> <option>Priya Singh</option>
                    <option>Amit Kumar</option>
                    <option>Meera Joshi</option>
                  </select>
                </div>
                <div className="fg">
                  
                  <label>
                    
                    Job <span className="sched-required">*</span>
                  </label>
                  <select className="og-select" defaultValue="">
                    
                    <option value=""> Select job… </option>
                    <option> JOB-2026-001 — Senior Frontend Developer </option>
                    <option> JOB-2026-002 — Product Manager </option>
                    <option> JOB-2026-004 — Data Analyst </option>
                  </select>
                </div>
                <div className="fg">
                  
                  <label>
                    
                    Round Name <span className="sched-required">*</span>
                  </label>
                  <input
                    className="og-input"
                    placeholder="e.g. Round 2 — Technical + System Design"
                  />
                </div>
                <div className="sched-date-time-grid">
                  
                  <div className="fg">
                    
                    <label>
                      
                      Date <span className="sched-required">*</span>
                    </label>
                    <input type="date" className="og-input" />
                  </div>
                  <div className="fg">
                    
                    <label>
                      
                      Time <span className="sched-required">*</span>
                    </label>
                    <input type="time" className="og-input" />
                  </div>
                </div>
                <div className="sched-date-time-grid">
                  
                  <div className="fg">
                    
                    <label>Duration</label>
                    <select className="og-select" defaultValue="60 min">
                      
                      <option>30 min</option> <option>45 min</option>
                      <option>60 min</option> <option>90 min</option>
                      <option>120 min</option>
                    </select>
                  </div>
                  <div className="fg">
                    
                    <label>Mode</label>
                    <select className="og-select" defaultValue="Video Call">
                      
                      <option>Video Call</option> <option>In-person</option>
                      <option>Phone</option>
                    </select>
                  </div>
                </div>
                <div className="fg">
                  
                  <label>
                    
                    Panel Members <span className="sched-required">*</span>
                  </label>
                  <select className="og-select sched-panel-select" multiple>
                    
                    <option>Priya Sharma</option> <option>Arun Mishra</option>
                    <option>Rahul Dev</option> <option>Neha Gupta</option>
                  </select>
                  <div className="sched-panel-help">
                    
                    Hold Ctrl/Cmd to select multiple
                  </div>
                </div>
                <div className="fg">
                  
                  <label> Meeting Link / Location </label>
                  <input
                    className="og-input"
                    placeholder="https://meet.google.com/… or conference room"
                  />
                </div>
              </div>
              <div className="modal-foot">
                
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => closeModal("sched")}
                >
                  
                  Cancel
                </button>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    closeModal("sched");
                    toast(
                      "Interview scheduled — email invite sent to candidate and panel",
                    );
                  }}
                >
                  
                  <i className="fa-solid fa-calendar-check"></i> Schedule &amp;
                  Send Invite
                </button>
              </div>
            </div>
          </div>
        )}
        {/* ===================================================== FEEDBACK MODAL ===================================================== */}
        {showModals.feedback && (
          <div
            className="modal-overlay open"
            id="feedbackModal"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closeModal("feedback");
              }
            }}
          >
            
            <div className="modal-box wide">
              
              <div className="modal-head">
                
                <div className="modal-icon feedback-modal-icon">
                  
                  <i className="fa-solid fa-star"></i>
                </div>
                <div className="feedback-modal-title-wrap">
                  
                  <div className="modal-title"> Interview Feedback </div>
                  <div className="modal-sub">
                    
                    Round 2 — HR Interview · Rahul Kumar
                  </div>
                </div>
                <button
                  className="modal-close-btn"
                  onClick={() => closeModal("feedback")}
                >
                  
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                
                <div id="fbAspects">
                  
                  {[
                    {
                      id: "r1",
                      title: "Technical Skills",
                      placeholder:
                        "Technical knowledge, depth of understanding…",
                    },
                    {
                      id: "r2",
                      title: "Communication",
                      placeholder: "Clarity, articulation, listening…",
                    },
                    {
                      id: "r3",
                      title: "Problem Solving",
                      placeholder: "Approach, reasoning, edge case handling…",
                    },
                    {
                      id: "r4",
                      title: "Attitude & Culture Fit",
                      placeholder: "Team fit, enthusiasm, growth mindset…",
                    },
                  ].map((aspect) => (
                    <div className="feedback-aspect" key={aspect.id}>
                      
                      <div className="feedback-aspect-header">
                        
                        <label className="feedback-aspect-label">
                          
                          {aspect.title}
                        </label>
                        <div className="feedback-rating">
                          
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
                            <button
                              key={rating}
                              type="button"
                              className={`feedback-rating-btn ${ratings[aspect.id] >= rating ? "feedback-rating-active" : ""}`}
                              onClick={() => setRating(aspect.id, rating)}
                            >
                              
                              {rating}
                            </button>
                          ))}
                        </div>
                      </div>
                      <textarea
                        className="og-textarea"
                        rows="2"
                        placeholder={aspect.placeholder}
                      />
                    </div>
                  ))}
                </div>
                <div className="feedback-recommendation">
                  
                  <label className="feedback-recommendation-title">
                    
                    Overall Recommendation
                  </label>
                  <div className="feedback-recommendation-options">
                    
                    <label className="feedback-recommendation-option">
                      
                      <input
                        type="radio"
                        name="rec"
                        className="feedback-radio-proceed"
                      />
                      <span className="feedback-proceed"> Proceed </span>
                    </label>
                    <label className="feedback-recommendation-option">
                      
                      <input
                        type="radio"
                        name="rec"
                        className="feedback-radio-maybe"
                      />
                      <span className="feedback-maybe"> Maybe </span>
                    </label>
                    <label className="feedback-recommendation-option">
                      
                      <input
                        type="radio"
                        name="rec"
                        className="feedback-radio-reject"
                      />
                      <span className="feedback-reject"> Reject </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-foot">
                
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => closeModal("feedback")}
                >
                  
                  Cancel
                </button>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    closeModal("feedback");
                    toast("Feedback submitted successfully");
                  }}
                >
                  
                  <i className="fa-solid fa-check"></i> Submit Feedback
                </button>
              </div>
            </div>
          </div>
        )}
        {/* ===================================================== RESCHEDULE MODAL ===================================================== */}
        {showModals.resched && (
          <div
            className="modal-overlay open"
            id="reschedModal"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closeModal("resched");
              }
            }}
          >
            
            <div className="modal-box">
              
              <div className="modal-head">
                
                <div className="modal-icon resched-modal-icon">
                  
                  <i className="fa-solid fa-calendar-pen"></i>
                </div>
                <div className="resched-modal-title-wrap">
                  
                  <div className="modal-title"> Reschedule Interview </div>
                </div>
                <button
                  className="modal-close-btn"
                  onClick={() => closeModal("resched")}
                >
                  
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                
                <div className="resched-date-time-grid">
                  
                  <div className="fg">
                    
                    <label>
                      
                      New Date
                      <span className="resched-required"> * </span>
                    </label>
                    <input type="date" className="og-input" />
                  </div>
                  <div className="fg">
                    
                    <label>
                      
                      New Time
                      <span className="resched-required"> * </span>
                    </label>
                    <input type="time" className="og-input" />
                  </div>
                </div>
                <div className="fg">
                  
                  <label>
                    
                    Reason
                    <span className="resched-optional"> (optional) </span>
                  </label>
                  <textarea
                    className="og-textarea"
                    rows="2"
                    placeholder="Why is the interview being rescheduled?"
                  />
                </div>
              </div>
              <div className="modal-foot">
                
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => closeModal("resched")}
                >
                  
                  Cancel
                </button>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    closeModal("resched");
                    toast("Interview rescheduled — updated invite sent");
                  }}
                >
                  
                  <i className="fa-solid fa-check"></i> Reschedule &amp;
                  Notify
                </button>
              </div>
            </div>
          </div>
        )}
        {/* ===================================================== CANCEL MODAL ===================================================== */}
        {showModals.cancel && (
          <div
            className="modal-overlay open"
            id="cancelModal"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closeModal("cancel");
              }
            }}
          >
            
            <div className="modal-box">
              
              <div className="modal-head">
                
                <div className="modal-icon cancel-modal-icon">
                  
                  <i className="fa-solid fa-xmark"></i>
                </div>
                <div className="cancel-modal-title-wrap">
                  
                  <div className="modal-title"> Cancel Interview? </div>
                </div>
                <button
                  className="modal-close-btn"
                  onClick={() => closeModal("cancel")}
                >
                  
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                
                <p className="cancel-modal-description">
                  
                  The interview will be cancelled. Candidate and panel will be
                  notified.
                </p>
                <div className="fg">
                  
                  <label>Reason</label>
                  <select
                    className="og-select"
                    defaultValue="Candidate withdrew"
                  >
                    
                    <option> Candidate withdrew </option>
                    <option> Schedule conflict </option>
                    <option> Position on hold </option>
                    <option> Candidate rejected </option>
                    <option> Other </option>
                  </select>
                </div>
                <label className="cancel-email-label">
                  
                  <input
                    type="checkbox"
                    className="cancel-email-checkbox"
                    defaultChecked
                  />
                  Send cancellation email to candidate and panel
                </label>
              </div>
              <div className="modal-foot">
                
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => closeModal("cancel")}
                >
                  
                  Keep Interview
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    closeModal("cancel");
                    toast("Interview cancelled — notifications sent", "warn");
                  }}
                >
                  
                  <i className="fa-solid fa-xmark"></i> Cancel Interview
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default InterviewsPage;
